// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DigitalSignatureDialog_dialog__3I-YR","preloader":"DigitalSignatureDialog_preloader__MTAMh"};